/* eslint-disable yola/react/require-default-props */
import React, { useCallback, forwardRef } from 'react';
import { useController } from 'react-hook-form';
import MultiSelect from '../multi-select';
import FieldStatus from '../field-status';
const defaultRules = {};
const defaultOptions = [];

const flattenOptions = (options) =>
  options.reduce((accumulator, option) => {
    if ('options' in option) {
      return accumulator.concat(option.options);
    }

    return accumulator.concat(option);
  }, []);

const MultiSelectField = forwardRef(
  (
    {
      options = defaultOptions,
      control,
      rules = defaultRules,
      placeholder = '',
      name,
      onChange,
      onBlur,
      ...otherProps
    },
    ref
  ) => {
    const { field, fieldState } = useController({
      name,
      control,
      rules,
    });

    const handleChange = useCallback(
      (selectedOptions) => {
        const nextValue = selectedOptions ? selectedOptions.map((opt) => opt.value) : null;
        field.onChange(nextValue);
        onChange?.(nextValue);
      },
      [field, onChange]
    );

    const handleBlur = useCallback(() => {
      field.onBlur();
      onBlur?.();
    }, [field, onBlur]);

    let defaultValue;

    const currentValues = field.value;

    if (currentValues && currentValues.length > 0) {
      const flatOpts = flattenOptions(options);
      defaultValue = currentValues.reduce((acc, val) => {
        const found = flatOpts.find((opt) => opt.value === val);
        if (found) {
          acc.push(found);
        }
        return acc;
      }, []);
    }

    return (
      <React.Fragment>
        <MultiSelect
          {...otherProps}
          ref={ref}
          onChange={handleChange}
          onBlur={handleBlur}
          options={options}
          defaultValue={defaultValue}
          placeholder={placeholder}
          name={field.name}
          invalid={fieldState.invalid}
        />
        {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
      </React.Fragment>
    );
  }
);

MultiSelectField.displayName = 'MultiSelectField';

export default MultiSelectField;
